import {
  GET_SEARCH_EMAIL_BEGIN, GET_SEARCH_EMAIL_SUCCESS, GET_SEARCH_EMAIL_FAILURE,
  GET_SEARCH_CNPJ_BEGIN, GET_SEARCH_CNPJ_SUCCESS, GET_SEARCH_CNPJ_FAILURE
} from './../constants/ActionTypes'

const initialState = {
  loading: false,
  error: null,
  result: null,

  emailCustomer: null,
  isLoadingEmailCustomer: false,
  errorEmailCustomer: false,

  cnpjCustomers: [],
  isLoadingCnpjCustomers: false,
  errorCnpjCustomers: false
}

const ReducerSearch = (state = initialState, { payload, type }) => {
  switch (type) {
      // Search Email
      case GET_SEARCH_EMAIL_BEGIN: {
          return {
              ...state,
              isLoadingEmailCustomer: true,
              errorEmailCustomer: null,
          }
      }
      case GET_SEARCH_EMAIL_SUCCESS: {
        return {
            ...state,
            emailCustomer: payload,
            isLoadingEmailCustomer: false,
            errorEmailCustomer: null,
        }
      }
      case GET_SEARCH_EMAIL_FAILURE: {
          const { error } = payload

          return {
              ...state,
              emailCustomer: null,
              isLoadingEmailCustomer: false,
              errorEmailCustomer: error,
          }
      }

      // Search Customers by CNPJ
      case GET_SEARCH_CNPJ_BEGIN: {
          return {
              ...state,
              isLoadingCnpjCustomers: true,
              errorCnpjCustomers: null,
          }
      }
      case GET_SEARCH_CNPJ_SUCCESS: {
          return {
              ...state,
              cnpjCustomers: payload,
              isLoadingCnpjCustomers: false,
              errorCnpjCustomers: null,
          }
      }
      case GET_SEARCH_CNPJ_FAILURE: {
          const { error } = payload

          return {
              ...state,
              cnpjCustomers: [],
              isLoadingCnpjCustomers: false,
              errorCnpjCustomers: error,
          }
      }
      default: return state
  }
}

export default ReducerSearch